export default __webpack_public_path__ + "static/media/World Economic Forum - Logo2.3d79e379.png";